import { Box, BoxProps, ColorOptions, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { AddNewEntity } from './AddNewEntity'

interface AddNewEntityProps {
  initialData?: any
  id?: string
  onUpdate?: () => void
  onClose: () => void
  selectedArr?: any
  show: boolean
}

export const UpdateEntity = ({ initialData = {}, id, onUpdate, onClose, selectedArr, show }: AddNewEntityProps) => {
  if (!show) {
    return null
  }
  return (
    <Box w={600}>
      <Box {...styles.container} bg={'#f8f9fc' as ColorOptions} flexDirection={'row'}>
        <Text fontFamily="jiotype-bold" color={'#214796' as ColorOptions} fontSize={16} title={'Edit Processor Data'} />
        <ButtonNew onPress={onClose} color={'#e74a3b' as ColorOptions} title={'Close'} borderRadius={4} height={30} />
      </Box>
      <AddNewEntity initialData={initialData} id={id} onUpdate={onUpdate} onClose={onClose} selectedArr={selectedArr} />
    </Box>
  )
}

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  container: {
    ...shadow,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
  listContainer: {
    ...shadow,
    backgroundColor: 'WHITE',
    padding: 16,
    underlayColor: 'WHITE',
    borderColor: '#e3e6f0' as ColorOptions,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  } as BoxProps,
}
